import React, {useState} from 'react';
import CustomHeader from '../../../components/mazraeKit/headers/homeHeader';

import MainFooter from '../../../components/mazraeKit/footers/footerMain';
import TabSwitcher from './switcher';
import AdsFavour from './ads';
import ShopsFavour from './shops';

const MyFavouriteAdd = () => {
  const [choosedMyAd, setChoosedMyAd] = useState('ads');

  return (
    <div className="flex w-full h-full flex-col justify-between">
      <CustomHeader
        title="مورد علاقه ها"
        preIcon="icon-nameArrow---Right"
        isActiveRightIcon
      />
      <TabSwitcher choosedMyAd={choosedMyAd} setChoosedMyAd={setChoosedMyAd} />
      <div className="d-flex w-full flex-col gap-3 h-full overflow-y-scroll px-3">
        <>
          {choosedMyAd === 'ads' ? (
            <>
              <AdsFavour />
            </>
          ) : (
            <>
              <ShopsFavour />
            </>
          )}
        </>
      </div>
      <MainFooter />
    </div>
  );
};

export default MyFavouriteAdd;
